module.exports = __webpack_public_path__ + "static/media/warning-info.bcbfbe9f.png";